import script from "./FundsDefaultSearches.vue?vue&type=script&setup=true&lang=js"
export * from "./FundsDefaultSearches.vue?vue&type=script&setup=true&lang=js"

import "./FundsDefaultSearches.vue?vue&type=style&index=0&id=270d1b1b&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-270d1b1b"]])

export default __exports__